<template>
  <svg viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path
        d="M16.5107 8.18427C16.5107 7.64046 16.4666 7.0937 16.3725 6.5587H8.82666V9.63935H13.1478C12.9685 10.6329 12.3923 11.5118 11.5487 12.0704V14.0693H14.1267C15.6406 12.6759 16.5107 10.6182 16.5107 8.18427Z"
        fill="#4285F4"
      />
      <path
        d="M8.82661 16.0005C10.9842 16.0005 12.8038 15.2921 14.1296 14.0693L11.5516 12.0704C10.8343 12.5583 9.90837 12.8346 8.82955 12.8346C6.74247 12.8346 4.97285 11.4266 4.33791 9.53352H1.67761V11.5942C3.03569 14.2956 5.80181 16.0005 8.82661 16.0005Z"
        fill="#34A853"
      />
      <path
        d="M4.33502 9.53353C3.99991 8.53996 3.99991 7.46408 4.33502 6.47051V4.40988H1.67766C0.542993 6.6704 0.542993 9.33364 1.67766 11.5942L4.33502 9.53353Z"
        fill="#FBBC04"
      />
      <path
        d="M8.82661 3.16644C9.96716 3.1488 11.0695 3.57798 11.8955 4.36578L14.1795 2.08174C12.7333 0.72367 10.8138 -0.0229773 8.82661 0.000539111C5.80181 0.000539111 3.03569 1.70548 1.67761 4.40987L4.33497 6.4705C4.96697 4.57449 6.73953 3.16644 8.82661 3.16644Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" transform="translate(0.666626)" />
      </clipPath>
    </defs>
  </svg>
</template>
